module.exports = __webpack_public_path__ + "static/media/playstore.d0263419.svg";